import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-keylobby-icon',
  templateUrl: './keylobby-icon.component.html',
  styles: []
})
export class KeylobbyIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
